import './styles/main.css';
import { registerSW } from 'virtual:pwa-register';
import { watchViewportHeight } from './ui/viewportHeight.js';
import { createGame } from './game.js';

// Corrige la hauteur réelle de l'appli sur mobile (voir ui/viewportHeight.js) : à faire avant
// tout affichage, pour ne jamais laisser paraître le calcul erroné de 100dvh sur certains WebKit.
watchViewportHeight();

// Service worker : mise en cache de la coquille de l'appli, mise à jour silencieuse au prochain lancement
registerSW({ immediate: true });

const game = createGame();
// En développement seulement : état du jeu accessible depuis la console (window.__zeroMaze.state)
if (import.meta.env.DEV) window.__zeroMaze = game;
game.start().catch((e) => console.error('[zero-maze] Démarrage impossible :', e));
